import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../environments/environment';

@Pipe({
  standalone: true,
  name: 'backgroundImage'
})
export class BackgroundImagePipe implements PipeTransform {

    private url: string = environment.api + '/images/backgroundImage/';

    transform(image: string | undefined): string {
      if (!image) {
        return '';
      }
      return this.url + image;
    }
}